import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Credits from './Credits';
const ReactGA = require('react-ga');
import axios from 'axios';
import logotagline from '../images/logo-tagline.png' // relative path to image

const propTypes = {
  score: PropTypes.number.isRequired
};

class Result extends Component {

  constructor(props) {
    super(props);
    this.state = {
      responseText: undefined,
      responseImage: undefined
    };
  }

  componentDidMount() {
    ReactGA.event({
      category: 'User',
      action: 'Quiz finished',
      value: this.props.score
    });

    axios.get('./data/quizResultResponses.json')
      .then( response => {
        response.data.quizResultResponses.every( (resultResponse, index) => {
          if( this.props.score >= resultResponse.scoreRange[0] && this.props.score <= resultResponse.scoreRange[1]){
            this.setState({
              responseText: resultResponse.responseText,
              responseImage: `result-image-${resultResponse.scoreRange[0]}-${resultResponse.scoreRange[1]}.gif`
            });
            return false; // break out from this every loop
          } else {
            return true; // continue every loop
          }
        });
      })
      .catch( error => {
        console.log(error);
      });
  }

  handleClickShare(event) {
    event.preventDefault();
    const intWidth = '500',
          intHeight = '400',
          strResize = 'yes',
          winTop = (screen.height / 2) - (intHeight / 2),
          winLeft = (screen.width / 2) - (intWidth / 2),
          strTitle = ((typeof event.target.getAttribute('title') !== 'undefined') ? event.target.getAttribute('title') : 'Social Share'),
          strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize + ',top=' + winTop + ',left=' + winLeft;
    window.open(event.target.getAttribute('href'), strTitle, strParam);
  }

  render() {
    const currentUrl = window.location.href,
          twitterText = `${this.props.strings.result.i_scored} ${this.props.score}/${this.props.totalQuestions}`,
          currentUrlWithScore = `${currentUrl}?score=${this.props.score}`,
          facebookText = currentUrlWithScore;

    if ( !this.state.responseText ) return <div></div>;

    return (
      <div>
        <img src={ logotagline } alt="" className="app-header-image" />
        <ReactCSSTransitionGroup
          className="container"
          component="div"
          transitionName="fade"
          transitionEnterTimeout={800}
          transitionLeaveTimeout={500}
          transitionAppear
          transitionAppearTimeout={500}
        >

          <div className="result__score">
            {this.props.strings.result.you_scored} {this.props.score}/{this.props.totalQuestions}
          </div>

          <div className="result__image">
            <img src={ './images/' + this.state.responseImage } alt="" />
            <div className="result__image-shadow" />
          </div>

          <div className="result__text">
            {this.state.responseText}
          </div>

          <a className="result__share result__share-facebook" href={"https://www.facebook.com/sharer/sharer.php?u=" + facebookText} target="_blank" onClick={this.handleClickShare}>{this.props.strings.result.share_results}</a>

          <a href={"https://twitter.com/intent/tweet?url=" + currentUrlWithScore + "&text=" + twitterText} className="result__share result__share-twitter" target="_blank" onClick={this.handleClickShare}>{this.props.strings.result.share_results}</a>

          <button className="result__restart" onClick={this.props.onClickRestart}>
            <span className="result__restart-text">{this.props.strings.result.retake_quiz}</span>
          </button>

          <Credits strings={this.props.strings.credits} />

        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

Result.propTypes = propTypes;

export default Result;



/** WEBPACK FOOTER **
 ** ./src/components/Result.js
 **/